// src/pages/Welcome/TestimonialsSection.jsx
import React from 'react';
import { COLORS, TYPOGRAPHY, LAYOUT, CARD_STYLES } from '../../constants';
import { DollarIcon, ShoppingIcon, RecycleIcon } from '../../components/Icons';

const TestimonialsSection = () => {
  const benefits = [
    {
      id: 1,
      title: "Save Money",
      description: "Find great deals on textbooks, furniture, electronics, and more from fellow students at affordable prices.",
      icon: DollarIcon
    },
    {
      id: 2,
      title: "Earn Extra Cash", 
      description: "Turn your unused items into money by selling to students who actually need them on campus.",
      icon: ShoppingIcon
    },
    {
      id: 3,
      title: "Sustainable Choice",
      description: "Reduce waste and environmental impact by giving items a second life within the ISU community.",
      icon: RecycleIcon
    }
  ];

  const sectionStyle = {
    padding: `${LAYOUT.sectionSpacing} ${LAYOUT.containerPadding}`,
    backgroundColor: COLORS.grayLight,
    position: 'relative',
  };

  const containerStyle = {
    maxWidth: LAYOUT.maxWidth,
    margin: '0 auto',
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: LAYOUT.spacing.xxxl,
  };

  const titleStyle = {
    ...TYPOGRAPHY.heading1,
    color: COLORS.text.primary,
    marginBottom: LAYOUT.spacing.lg,
    fontSize: 'clamp(2rem, 4vw, 2.5rem)',
    fontWeight: '700',
  };

  const subtitleStyle = {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: 'clamp(1.1rem, 2vw, 1.25rem)',
    maxWidth: '600px',
    margin: '0 auto',
    lineHeight: '1.6',
  };

  const benefitsGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: LAYOUT.spacing.xl,
    alignItems: 'stretch',
  };

  const benefitCardStyle = {
    ...CARD_STYLES.base,
    padding: LAYOUT.spacing.xxl,
    textAlign: 'center',
    position: 'relative',
    transition: 'all 0.3s ease',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
  };

  const iconContainerStyle = {
    width: '72px',
    height: '72px',
    borderRadius: LAYOUT.borderRadius.full,
    backgroundColor: COLORS.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: `0 auto ${LAYOUT.spacing.xl} auto`,
    boxShadow: `0 4px 16px ${COLORS.shadow}`,
  };

  const benefitTitleStyle = {
    ...TYPOGRAPHY.heading3,
    color: COLORS.text.primary,
    fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
    fontWeight: '600',
    marginBottom: LAYOUT.spacing.md,
  };

  const benefitDescriptionStyle = {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: '16px',
    lineHeight: '1.6',
    maxWidth: '280px',
    margin: '0 auto',
  };

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>Smart Benefits for Students</h2>
          <p style={subtitleStyle}>
            More than just buying and selling - discover the financial and environmental advantages
          </p>
        </div>

        <div style={benefitsGridStyle}>
          {benefits.map((benefit) => {
            const IconComponent = benefit.icon;
            
            return (
              <div 
                key={benefit.id} 
                style={benefitCardStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.08)';
                }}
              >
                <div style={iconContainerStyle}>
                  <IconComponent size={32} color="white" fill="white" style={{ color: 'white !important', fill: 'white !important' }} />
                </div>
                
                <h3 style={benefitTitleStyle}>{benefit.title}</h3>
                <p style={benefitDescriptionStyle}>{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;